import {
  ChartBarIcon,
  CogIcon,
  InformationCircleIcon,
} from '@heroicons/react/outline'
import MusicNoteIcon from '@heroicons/react/outline/MusicNoteIcon'

type Props = {
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
}

export const Navbar = ({
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsSettingsModalOpen,
}: Props) => {
  return (
    <div className="navbar">
      <div className="navbar-content px-5">
        <InformationCircleIcon
          className="h-6 w-10 mr-5 cursor-pointer dark:stroke-white"
          onClick={() => setIsInfoModalOpen(true)}
        />
        <div>
        <p className="text-xl text-center ml-5 font-bold dark:text-white">AJRdle</p>
      </div>
        <div className="right-icons">
          <ChartBarIcon
            className="h-6 w-6 mr-2 cursor-pointer dark:stroke-white"
            onClick={() => setIsStatsModalOpen(true)}
          />
          <CogIcon
            className="h-6 w-6 mr-2 cursor-pointer dark:stroke-white"
            onClick={() => setIsSettingsModalOpen(true)}
          />
          <a href="https://bang.ajrdle.com">
            <MusicNoteIcon
              className="h-6 w-6 cursor-pointer dark:stroke-white"
            /></a>
        </div>
      </div>
      <hr></hr>
    </div>
  )
}
